import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'deviceManagementExperience.devicePositions'

const DeviceManagementDevicePositionsSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DeviceManagementDevicePositionsSlice
